const GLOBAL_ADMIN_POLICY_LIST_CACHE_ID = 'GlobalAdminPolicyListCacheId';

export {GLOBAL_ADMIN_POLICY_LIST_CACHE_ID};
